<template>
  <div class="galeria-container">
    <app-header rootClassName="header-root-class-name8"></app-header>
    <div class="galeria-testimonial">
      <div class="galeria-container1">
        <h1 class="galeria-text">
          <span>Conoce a nuestros docentes</span>
          <br />
        </h1>
        <div class="galeria-container2">
          <app-docente rootClassName="docente-root-class-name27"></app-docente>
          <app-docente rootClassName="docente-root-class-name28"></app-docente>
          <app-docente rootClassName="docente-root-class-name29"></app-docente>
          <app-docente rootClassName="docente-root-class-name30"></app-docente>
          <app-docente rootClassName="docente-root-class-name31"></app-docente>
          <app-docente rootClassName="docente-root-class-name32"></app-docente>
          <app-docente rootClassName="docente-root-class-name33"></app-docente>
          <app-docente rootClassName="docente-root-class-name34"></app-docente>
          <app-docente rootClassName="docente-root-class-name35"></app-docente>
          <app-docente rootClassName="docente-root-class-name36"></app-docente>
          <app-docente rootClassName="docente-root-class-name37"></app-docente>
          <app-docente rootClassName="docente-root-class-name38"></app-docente>
          <app-docente rootClassName="docente-root-class-name39"></app-docente>
          <app-docente rootClassName="docente-root-class-name40"></app-docente>
          <app-docente rootClassName="docente-root-class-name41"></app-docente>
          <app-docente rootClassName="docente-root-class-name42"></app-docente>
          <app-docente rootClassName="docente-root-class-name43"></app-docente>
          <app-docente rootClassName="docente-root-class-name44"></app-docente>
          <app-docente rootClassName="docente-root-class-name45"></app-docente>
          <app-docente rootClassName="docente-root-class-name46"></app-docente>
          <app-docente rootClassName="docente-root-class-name47"></app-docente>
          <app-docente rootClassName="docente-root-class-name48"></app-docente>
          <app-docente rootClassName="docente-root-class-name49"></app-docente>
          <app-docente rootClassName="docente-root-class-name50"></app-docente>
        </div>
      </div>
    </div>
    <app-footer rootClassName="footer-root-class-name2"></app-footer>
  </div>
</template>

<script>
import AppHeader from '../components/header'
import AppDocente from '../components/docente'
import AppFooter from '../components/footer'

export default {
  name: 'Galeria',
  components: {
    AppHeader,
    AppDocente,
    AppFooter,
  },
  metaInfo: {
    title: 'Galeria - ColegioTasco',
    meta: [
      {
        property: 'og:title',
        content: 'Galeria - ColegioTasco',
      },
    ],
  },
}
</script>

<style scoped>
.galeria-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}
.galeria-testimonial {
  width: 100%;
  display: flex;
  margin-top: var(--dl-space-space-threeunits);
  margin-bottom: var(--dl-space-space-threeunits);
  justify-content: center;
}
.galeria-container1 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-default);
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.galeria-text {
  font-size: 3em;
  margin-bottom: var(--dl-space-space-threeunits);
}
.galeria-container2 {
  width: 100%;
  height: auto;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
@media(max-width: 1366px) {
  .galeria-text {
    color: var(--dl-color-gray-black);
  }
}
@media(max-width: 991px) {
  .galeria-text {
    color: var(--dl-color-gray-black);
    text-align: center;
  }
  .galeria-container2 {
    grid-template-columns: 1fr 1fr;
  }
}
@media(max-width: 767px) {
  .galeria-container1 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
}
@media(max-width: 720px) {
  .galeria-text {
    color: var(--dl-color-gray-black);
  }
}
@media(max-width: 479px) {
  .galeria-container1 {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
}
@media(max-width: 393px) {
  .galeria-container1 {
    padding-left: var(--dl-space-space-halfunit);
    padding-right: var(--dl-space-space-halfunit);
  }
  .galeria-text {
    color: var(--dl-color-gray-black);
  }
  .galeria-container2 {
    grid-template-columns: 1fr;
  }
}
</style>
